import { useEffect } from 'react';
import { sitePath } from '../Content/useSiteContent';

export default function AdminRedirect() {
  useEffect(() => {
    window.location.replace(sitePath('admin/index.html') + window.location.search + window.location.hash);
  }, []);
  return <p className="content-notice">Opening the website editor…</p>;
}
